module.exports = __webpack_public_path__ + "static/media/Swashakthi-SHG-call-to-action-1.fa1c8b54.webp";